export const playerRoleOptions = [
  {
    value: '1',
    label: 'Player',
  },
  {
    value: '2',
    label: 'Coach',
  },
  {
    value: '3',
    label: 'Physio',
  },
  {
    value: '4',
    label: 'Staff',
  },
  {
    value: '5',
    label: 'Other',
  },
];

export const playerPositionOptions = [
  {
    value: '0',
    label: '--',
  },
  {
    value: '1',
    label: 'Goalkeeper',
  },
  {
    value: '2',
    label: 'Right Back',
  },
  {
    value: '3',
    label: 'Left Back',
  },
  {
    value: '4',
    label: 'Centre Back Left',
  },
  {
    value: '5',
    label: 'Centre Back Right',
  },
  {
    value: '6',
    label: 'Centre Mid Left',
  },
  {
    value: '7',
    label: 'Centre Mid Right',
  },
  {
    value: '8',
    label: 'Right Wing',
  },
  {
    value: '9',
    label: 'Left Wing',
  },
  {
    value: '10',
    label: 'Centre Forward',
  }
];

export const dominantFootOptions = [
  {
    value: 'l',
    label: 'Left',
  },
  {
    value: 'r',
    label: 'Right',
  },
];

export const shoeSizeTypeOptions = [
  {
    value: 'uk',
    label: 'UK',
  },
  {
    value: 'eu',
    label: 'EU (Male)',
  },
  {
    value: 'fe',
    label: 'EU (Female)',
  },
  {
    value: 'us',
    label: 'US (Male)',
  },
  {
    value: 'fu',
    label: 'US (Female)',
  },
];

export const genderOptions = [
  {
    value: 'm',
    label: 'Male',
  },
  {
    value: 'f',
    label: 'Female',
  },
  {
    value: 'o',
    label: 'Other',
  },
  {
    value: 'u',
    label: 'Prefer not to say',
  },
];
